  //Sidebar- Description and Feature
var acc = document.getElementsByClassName("custom-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("custom-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

//Faq at the bottom
var acc = document.getElementsByClassName("faq-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("faq-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

  $(".custom-default-slider").slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
            autoplay: true,  
            slidesToShow: 1,
            slidesToScroll: 1
            }
          }
        ]  
      });
  
   $(".product-slider-wrapper .custom-code-Black").slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
            autoplay: true,  
            slidesToShow: 1,
            slidesToScroll: 1
            }
          }
        ]  
  });     
  
  $(".product-slider-wrapper .custom-code-Cognac").slick({
        dots: false,
        infinite: true,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
            autoplay: true,  
            slidesToShow: 1,
            slidesToScroll: 1
            }
          }
        ]  
  });    
 
    if (window.location.href.indexOf("zen-4") > -1) {  
          function updateMassageImages() {

              // Get selected color
              const colorName = $('.colour .variant-picker__option-info span').text().trim();
              if (!colorName) return;
              const variantCode = 'custom-code-' + colorName;

              //Massage Images
              $('.massage-label img').addClass('custom-hide');
                  $('.massage-label img[massage-variant="' + variantCode + '"]').removeClass('custom-hide');

              //Featured Images
              $('.featured-image-wrapper img').addClass('custom-hide');
              $('.featured-image-wrapper img.' + variantCode).removeClass('custom-hide');

              //Two Column Images
              $('.two-columns-wrapper img').addClass('custom-hide');
              $('.two-columns-wrapper img.' + variantCode).removeClass('custom-hide');

              //Product Slider
              $('.product-slider-wrapper .slider-wrapper-both').addClass('custom-hide');
              $('.product-slider-wrapper .outer-' + variantCode).removeClass('custom-hide');
              $('.product-slider-wrapper .' + variantCode).slick('refresh');

              //Gallery Images
              $('product-gallery .secondary_images_below_gallery').addClass('custom-hide');
              $('product-gallery .secondary_images_below_gallery.' + variantCode).removeClass('custom-hide');

          }

          function initCustomVariantImages() {
                $('.massage-label').remove();
                $('.wheeloptions .custom-product-image').remove();
                let massage_status = '<div class="massage-label"><img massage-variant="custom-code-Cognac" class="custom-code-Cognac custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/cognac-no-massage.png"><img massage-variant="custom-code-Black" class="custom-code-Black custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/black-no-massage.png"></div>';
                $('.massageoption label').eq(0).append(massage_status);
                let massage_status1 = '<div class="massage-label"><img massage-variant="custom-code-Cognac" class="custom-code-Cognac custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/cognac-massage.png"><img massage-variant="custom-code-Black" class="custom-code-Black custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/black-massager.png"></div>';
                $('.massageoption label').eq(1).append(massage_status1);
                $('.wheeloptions label').eq(0).append(
                    '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/regular-wheel.png">'
                );
                $('.wheeloptions label').eq(1).append(
                    '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/caster-wheel.png">'
                );
          }  
          jQuery(document).ready(function () {
            initCustomVariantImages(); 
            updateMassageImages();
          });
          document.addEventListener('variant:change', function () {
            initCustomVariantImages(); 
            updateMassageImages();
          });


    }
    else if (window.location.href.indexOf("zen-2") > -1) { 
          function initCustomVariantImages() {
            $('.massage-label').remove();
            $('.wheeloptions .custom-product-image').remove();
            let massage_status = '<div class="massage-label"><img massage-variant="custom-code-Cognac" class="custom-code-Cognac" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/zen-2-no-massage.png"></div>';
            $('.massageoption label').eq(0).append(massage_status);
            let massage_status1 = '<div class="massage-label"><img massage-variant="custom-code-Cognac" class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/zen-2-massage.png"></div>';
            $('.massageoption label').eq(1).append(massage_status1);
            $('.wheeloptions label').eq(0).append(
                '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/regular-wheel.png">'
            );
            $('.wheeloptions label').eq(1).append(
                '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/caster-wheel.png">'
            );
        }  
        jQuery(document).ready(function () {
          initCustomVariantImages(); 
        });
        document.addEventListener('variant:change', function () {
          initCustomVariantImages(); 
        });
    }  
    else if (window.location.href.indexOf("zen-3") > -1) { 
        function initCustomVariantImages() {
            $('.massage-label').remove();
            $('.wheeloptions .custom-product-image').remove();
            let massage_status = '<div class="massage-label"><img massage-variant="custom-code-Cognac" class="custom-code-Cognac" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/zen-2-no-massage.png"></div>';
            $('.massageoption label').eq(0).append(massage_status);
            let massage_status1 = '<div class="massage-label"><img massage-variant="custom-code-Cognac" class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/zen-2-massage.png"></div>';
            $('.massageoption label').eq(1).append(massage_status1);
            $('.wheeloptions label').eq(0).append(
                '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/regular-wheel.png">'
            );
            $('.wheeloptions label').eq(1).append(
                '<img class="custom-product-image" src="https://cdn.shopify.com/s/files/1/0647/7912/4915/t/4/assets/caster-wheel.png">'
            );
        }  
        jQuery(document).ready(function () {
          initCustomVariantImages(); 
        });
        document.addEventListener('variant:change', function () {
          initCustomVariantImages(); 
        });
        }  
    jQuery(document).ready(function(){
      setTimeout(function () { 
        var wrapper = jQuery('#below-gallery-wrapper').html();
        jQuery(wrapper).insertAfter('#magic-zoom-plus-block');
      }, 2000);

      setTimeout(function () { 
          //Hide SIRV Branding
          jQuery('.sirv-spin.smv-cursor-zoom-in').next('a').attr('style','display: none !important');
      }, 4000);  
        
    }); 

document.addEventListener("DOMContentLoaded", () => {

    const drawer = document.querySelector("#header-sidebar-menu");
    const closeBtn = drawer.querySelector('[is="close-button"]');

    closeBtn.addEventListener("click", function(e){

        e.preventDefault();
        e.stopImmediatePropagation();

        drawer.classList.add("drawer-closing");

        setTimeout(() => {
            drawer.removeAttribute("open");
            drawer.classList.remove("drawer-closing");
        },1000);

    }, true);

});